// 用 localStorage 模擬「後端資料庫」：重新整理頁面後資料不會消失。
// 這不是真正的離線同步（見 5.10），只是讓 demo 操作起來更像真實產品。
export const STORAGE_KEY = 'trip-memories-demo-state-v1'

export function loadPersisted () {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export function persistPlugin (store) {
  store.subscribe((mutation, state) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
    } catch (e) {
      // 儲存空間不足或無痕模式時忽略即可，不影響前端操作
    }
  })
}

export function clearPersisted () {
  try {
    window.localStorage.removeItem(STORAGE_KEY)
  } catch (e) {
    // ignore
  }
}
